export const CELL_EXPORT_TYPES = {
    csv: {
        key: 'csv',
        title: 'CSV'
    },
    image: {
        key: 'image',
        title: 'Afbeelding'
    }
}

export const CELL_TYPES = {
    tile: {
        key: 'tile',
        icon: 'score',
        title: 'Waarde',
        info: 'Geef een enkele meetwaarde weer voor een snelle statuscontrole',
        defaultTile: {
            w: 3,
            h: 3,
            graph: {
                request: {
                    isWritable: false
                },
                fields: []
            }
        },
        config: {
            exportTypes: [CELL_EXPORT_TYPES.csv],
            maxSeries: 1
        },
        viewComponent: () => import('./../components/graphs2/eod-graph-tile.vue'),
        configurationComponent: () => import('./../components/graphs2/configuration/eod-graph-tile.vue')
    },
    sankey: {
        key: 'sankey',
        icon: 'flowchart',
        title: 'Stroomdiagram',
        info: 'Geef verbindingen weer a.d.h.v. een stroomdiagram',
        defaultTile: {
            w: 3,
            h: 6,
            graph: {}
        },
        config: {
            exportTypes: [CELL_EXPORT_TYPES.csv, CELL_EXPORT_TYPES.image],
            maxSeries: 1
        },
        viewComponent: () => import('./../components/graphs2/eod-graph-sankey.vue'),
        configurationComponent: () => import('./../components/graphs2/configuration/eod-graph-sankey.vue')
    },
    table: {
        key: 'table',
        icon: 'table_chart',
        title: 'Tabel',
        info: 'Toon gestructureerde gegevens in een tabel voor gedetailleerd inzicht',
        defaultTile: {
            w: 6,
            h: 10,
            graph: {
                fields: []
            },
        },
        config: {
            exportTypes: [CELL_EXPORT_TYPES.csv],
        },
        viewComponent: () => import('./../components/graphs2/eod-graph-table.vue'),
        configurationComponent: () => import('./../components/graphs2/configuration/eod-graph-table.vue')
    },
    pivot_table: {
        key: 'pivot_table',
        icon: 'table_chart',
        title: 'Draaitabel',
        info: 'Gebruik groeperingen om rij en hoofding te bepalen van de tabel',
        defaultTile: {
            w: 6,
            h: 10,
            graph: {},
        },
        config: {
            exportTypes: [CELL_EXPORT_TYPES.csv],
            maxSeries: 1
        },
        viewComponent: () => import('./../components/graphs2/eod-graph-pivot-table.vue'),
        configurationComponent: () => import('./../components/graphs2/configuration/eod-graph-pivot-table.vue')
    },
    line: {
        key: 'line',
        icon: 'stacked_line_chart',
        title: 'Lijngrafiek',
        info: 'Gebruik een lijngrafiek om de trend van uw data weer te geven',
        defaultTile: {
            w: 4,
            h: 6,
            graph: {
                options: {
                    legend: {
                        show: true
                    },
                    yAxis: {
                        scale: false
                    }
                }
            },
        },
        config: {
            exportTypes: [CELL_EXPORT_TYPES.csv, CELL_EXPORT_TYPES.image]
        },
        viewComponent: () => import('./../components/graphs2/eod-graph-line.vue'),
        configurationComponent: () => import('./../components/graphs2/configuration/eod-graph-line.vue')
    },
    profile: {
        key: 'profile',
        icon: 'full_stacked_bar_chart',
        title: 'Profiel',
        info: null,
        defaultTile: {
            w: 4,
            h: 6,
            graph: {
                options: {
                    legend: {
                        show: true
                    }
                }

            },
        },
        config: {
            exportTypes: [CELL_EXPORT_TYPES.csv, CELL_EXPORT_TYPES.image]
        },
        viewComponent: () => import('./../components/graphs2/eod-graph-profile.vue'),
        configurationComponent: () => import('./../components/graphs2/configuration/eod-graph-profile.vue')
    },
    bar: {
        key: 'bar',
        icon: 'align_vertical_bottom',
        title: 'Staafgrafiek',
        info: null,
        defaultTile: {
            w: 4,
            h: 6,
            graph: {
                options: {
                    legend: {
                        show: true
                    }
                }
            },
        },
        config: {
            exportTypes: [CELL_EXPORT_TYPES.csv, CELL_EXPORT_TYPES.image]
        },
        viewComponent: () => import('./../components/graphs2/eod-graph-bar.vue'),
        configurationComponent: () => import('./../components/graphs2/configuration/eod-graph-bar.vue')
    },
    heatmap: {
        key: 'heatmap',
        icon: 'gradient',
        title: 'Heatmap',
        info: 'Gebruik een heatmap om patronen en intensiteit in uw data te benadrukken',
        defaultTile: {
            w: 4,
            h: 6,
            graph: {
                options: {
                    visualMap: {
                        min: 0,
                        max: 10
                    },
                    legend: {
                        show: true
                    }
                }
            },
        },
        config: {
            exportTypes: [CELL_EXPORT_TYPES.csv, CELL_EXPORT_TYPES.image]
        },
        viewComponent: () => import('./../components/graphs2/eod-graph-heatmap.vue'),
        configurationComponent: () => import('./../components/graphs2/configuration/eod-graph-heatmap.vue')
    },
    heatmap_timed: {
        key: 'heatmap_timed',
        icon: 'gradient',
        title: 'Heatmap tellerstand',
        info: 'Gebruik een heatmap om patronen en intensiteit in uw data te benadrukken a.d.h.v. een start-, einddatum en totaal verbruik',
        defaultTile: {
            w: 4,
            h: 6,
            graph: {
                startDate: null,
                endDate: null,
                maxUsage: 0,
                options: {
                    visualMap: {
                        min: 0,
                        max: 10,
                        inRange: {
                            color: ['#bbccf2', '#255ed9']
                        }
                    },
                    legend: {
                        show: true
                    }
                }
            },
        },
        config: {
            exportTypes: [CELL_EXPORT_TYPES.csv, CELL_EXPORT_TYPES.image]
        },
        viewComponent: () => import('./../components/graphs2/eod-graph-heatmap-timed.vue'),
        configurationComponent: () => import('./../components/graphs2/configuration/eod-graph-heatmap-timed.vue')
    },
    gauge: {
        key: 'gauge',
        icon: 'multiline_chart',
        title: 'Graadmeter',
        info: 'Visualiseer een meetwaarde ten opzichte van een doel of drempelwaarde',
        defaultTile: {
            w: 4,
            h: 8,
            graph: {
                options: {
                    legend: {
                        show: true
                    }
                }
            },
        },
        config: {
            exportTypes: [CELL_EXPORT_TYPES.csv, CELL_EXPORT_TYPES.image]
        },
        viewComponent: () => import('./../components/graphs2/eod-graph-gauge.vue'),
        configurationComponent: () => import('./../components/graphs2/configuration/eod-graph-gauge.vue')
    },
    liquid: {
        key: 'liquid',
        icon: 'humidity_percentage',
        title: 'Vulgraad (%)',
        info: 'Gebruik een niveaumeter om de vulling van een tank of buffer visueel weer te geven en het percentage van de maximale capaciteit te tonen',
        defaultTile: {
            w: 4,
            h: 8,
            graph: {
                options: {
                    legend: {
                        show: true
                    }
                }
            },
        },
        config: {
            exportTypes: [CELL_EXPORT_TYPES.csv, CELL_EXPORT_TYPES.image],
            maxSeries: 1
        },
        viewComponent: () => import('./../components/graphs2/eod-graph-liquid.vue'),
        configurationComponent: () => import('./../components/graphs2/configuration/eod-graph-liquid.vue')
    },
    water_level: {
        key: 'water_level',
        icon: 'water_pump',
        title: 'Waterniveau',
        info: '',
        defaultTile: {
            w: 4,
            h: 14,
            graph: {
                measuringRangeFieldDefault: 5
            },
        },
        config: {
            exportTypes: [],
            maxSeries: 6
        },
        viewComponent: () => import('./../components/graphs2/eod-graph-water-level.vue'),
        configurationComponent: () => import('./../components/graphs2/configuration/eod-graph-water-level.vue')
    },
    pie: {
        key: 'pie',
        icon: 'pie_chart',
        title: 'Taartgrafiek',
        info: 'Gebruik een taartdiagram om de verdeling van uw data visueel weer te geven',
        defaultTile: {
            w: 4,
            h: 8,
            graph: {
                tooltip: {
                    valueFormat: null
                },
                options: {
                    legend: {
                        show: true
                    }
                }
            },
        },
        config: {
            exportTypes: [CELL_EXPORT_TYPES.csv, CELL_EXPORT_TYPES.image],
            maxSeries: 1
        },
        viewComponent: () => import('./../components/graphs2/eod-graph-pie.vue'),
        configurationComponent: () => import('./../components/graphs2/configuration/eod-graph-pie.vue')
    },
    text: {
        key: 'text',
        icon: 'text_fields',
        title: 'Tekst',
        info: 'Toon belangrijke informatie met optioneel een directe link naar aanvullende details',
        steps: [1, 3],
        defaultTile: {
            w: 4,
            h: 8,
            graph: {
                content: null
            },
        },
        viewComponent: () => import('./../components/graphs2/eod-graph-text.vue'),
        configurationComponent: () => import('./../components/graphs2/configuration/eod-graph-text.vue')
    },
    image: {
        key: 'image',
        icon: 'image',
        title: 'Afbeelding',
        info: 'Upload een afbeelding om weer te geven op het dashboard',
        steps: [1, 3],
        defaultTile: {
            w: 4,
            h: 8,
            graph: {
                src: null
            },
        },
        viewComponent: () => import('./../components/graphs2/eod-graph-image.vue'),
        configurationComponent: () => import('./../components/graphs2/configuration/eod-graph-image.vue')
    },
    medialibrary: {
        key: 'medialibrary',
        icon: 'photo_library',
        title: 'Mediatheek',
        info: 'Toon de bestanden in de mediatheek, gefilterd op de dynamische filters',
        steps: [1, 3],
        defaultTile: {
            w: 4,
            h: 8,
            graph: {
                hideTags: false
            },
        },
        viewComponent: () => import('./../components/graphs2/eod-graph-medialibrary.vue'),
        configurationComponent: () => import('./../components/graphs2/configuration/eod-graph-medialibrary.vue')
    },
    map: {
        key: 'map',
        icon: 'map',
        title: 'Kaart',
        info: 'Geef uw projecten of assets weer op een interactieve kaart',
        steps: [1, 3],
        defaultTile: {
            w: 4,
            h: 8,
            graph: {
                endpoints: [],
                onlyDashboards: false,
                showTable: false,
            },
        },
        viewComponent: () => import('./../components/graphs2/eod-graph-map.vue'),
        configurationComponent: () => import('./../components/graphs2/configuration/eod-graph-map.vue')
    }
};

export const CELL_GROUPS = {
    graphs: {
        key: 'graphs',
        title: 'Grafieken',
        cellTypes: [CELL_TYPES.tile, CELL_TYPES.table, CELL_TYPES.pivot_table, CELL_TYPES.line, CELL_TYPES.pie, CELL_TYPES.gauge, CELL_TYPES.liquid, CELL_TYPES.heatmap, CELL_TYPES.heatmap_timed, CELL_TYPES.bar, CELL_TYPES.profile, CELL_TYPES.water_level]
    },
    other: {
        key: 'other',
        title: 'Andere',
        cellTypes: [CELL_TYPES.text, CELL_TYPES.image, CELL_TYPES.medialibrary, CELL_TYPES.map]
    }
}